module.exports = __webpack_public_path__ + "static/media/C3.7d0e6b1f.png";